/*
 * 文件EN: artificialAudit.js,
 * 文件CN: 人工复核,
 * 创建时间: Wednesday, 29th April 2020 5:41:38 pm,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */
import request from '@/plugins/http';
import qs from 'qs';

// 列表获取
export const getListData = params => {
  return request.get('/manualReview/query', params)
}

/**
 * @desc 审核操作
 * @method POST
 * @param { 参数说明
    * expectQuota: 期望额度
    * hqResult: 总部审批结果
    * hqResultCode: 总部审批代码
    * manualReview: 人工复核 0:通过 1:拒绝 2:驳回
    * manualReviewResult: 人工复核审批结果
    * merId: 商户id
    * stateAudit: 审核状态 0:等待总部审核 1:总部通过(等待渠道审核） 2:总部驳回 3:总部拒绝 4: 渠道不通过(资料问题导致等) 5:渠道拒绝(无法重新申请) 6:渠道审核通过（等待发卡）7:转移发行 8:发卡-未激活 9:发卡已激活（正常） 10:触发自动审核 11:待处理（等待自动审核）12:触人工复核 * 12:触发人工复核\n *13:通过人工复核(等待渠道审核） 14:人工驳回 15:人工拒绝
    * } 
    */
export const confirm = params => {
  return request.post('/manualReview/confirm', qs.stringify(params))
}

export const approvalHistory = params => {
  return request.get('/manualReview/approvalHistory', params)
}

// 上送 
export const selectMerIdByBank = params => {
  return request.get('/manualReview/selectMerIdByBank', params)
}

// 审核报告导出pdf
export const auditReportExportPdf = params => {
  return request.post('/manualReview/auditReportExportPdf', qs.stringify(params))
}